<template>
  <v-row class="pl-3">
    <v-col>
      <v-row class="ma-0">
        <v-chip
          filter
          outlined
          class="mr-2 env-chip"
          :color="
            getSession(env.name) && getSession(env.name).id
              ? 'success'
              : 'error'
          "
          :disabled="!$v(getSession(env.name), 'id')"
          :input-value="selectedEnv === env.name"
          :value="env.name"
          :key="env.name"
          @click="() => (selectedEnv = env.name)"
          v-for="env in possibleEnvs"
        >
          {{ env.name }}
        </v-chip>
      </v-row>
      <v-row dense>
        <span v-if="!isSessionExists(selectedEnv)" class="error--text">
          <v-icon class="mr-2" color="error">mdi-alert</v-icon>
          {{ warnings[selectedEnv] }}
        </span>
      </v-row>
      <template v-if="!(getSession() && getSession().id)">
        <v-row dense class="pt-6">
          <v-form class="form" ref="form" v-model="valid" lazy-validation>
            <v-autocomplete
              disabled
              v-model="selectedBusiness"
              :items="business"
              :rules="businessRules"
              :loading="isLoading"
              :search-input.sync="searchBusiness"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Select practice"
              placeholder="Start typing to Search"
              return-object
            />
          </v-form>
        </v-row>
        <v-row v-if="selectedBusiness">
          <v-col class="pa-0">
            <a
              class="text-decoration-none"
              :href="portalEnvsLinksMap[selectedEnv] + selectedBusiness.id"
              target="_blank"
            >
              Check practice on Rhapsody Portal - Practice ID:
              {{ selectedBusiness.id }}
            </a>
            <p class="subtitle-2 pt-1">
              Please make sure that you're using account that have access to see
              selected practice
            </p>
          </v-col>
        </v-row>
      </template>

      <v-row v-else>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                Practice name:
                {{ getSession().business.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                Practice ID:
                {{ getSession().business.rhapsody_id }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash';
import CONFIG from '../../../config';
import { EnvsNamesMap, PortalPracticesLinksMap } from '@/constants';
import { businessApiV1, tasksApiV1 } from '@/api/v1';
import { businessApiV2, tasksApiV2 } from '@/api/v2';

export default {
  props: {
    task_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      valid: true,
      task: {},
      selectedEnv: null,
      business: [],
      searchBusiness: null,
      selectedBusiness: undefined,
      businessRules: [(v) => !!v || 'Practice is required'],
      isLoading: false,
      possibleEnvs: [
        {
          name: EnvsNamesMap.STAGE
        },
        {
          name: EnvsNamesMap.MASTER
        },
        {
          name: EnvsNamesMap.PROD
        }
      ],
      portalEnvsLinksMap: PortalPracticesLinksMap,
      warnings: {
        [EnvsNamesMap.STAGE]:
          "You haven't import session for Stage Environment",
        [EnvsNamesMap.MASTER]:
          "You haven't import session for Play Environment",
        [EnvsNamesMap.PROD]: "You haven't import session for Prod Environment"
      }
    };
  },
  mounted() {
    this.getTask().then(() => {
      this.selectedEnv = CONFIG.ENV;
    });
  },
  watch: {
    searchBusiness: _.debounce(function (newVal, prevVal) {
      // Items have already been requested
      if (this.isLoading) return;

      if (newVal !== prevVal) {
        this.isLoading = true;

        return this.getBusinesses(newVal);
      }
      // Lazily load input items
    }, 1000),
    selectedEnv(newVal, prevVal) {
      this.business = [];
      if (newVal !== prevVal) {
        console.log('selectedEnv:', newVal);
        this.isLoading = true;
        this.$emit('onEnvChanged', this.selectedEnv);

        if (!(this.getSession(newVal) && this.getSession(newVal).id)) {
          return this.getBusinesses(this.searchBusiness);
        }
      }
      // Lazily load input items
    }
  },
  methods: {
    isSessionExists(env) {
      console.log('env2: ', env);
      const neededSession = this.getSession(env);
      console.log('neededSession: ', neededSession);
      return Boolean(neededSession && neededSession.id);
    },
    getSession(name) {
      return this.task[`${name || this.selectedEnv}Session`];
    },
    getBusinesses(search = '') {
      (this.$store.getters.isMatcherApiV2Enabled
        ? businessApiV2
        : businessApiV1
      )
        .fetchBusinesses({ search, environment: this.selectedEnv })
        .then((res) => {
          const { items } = res;
          this.business = items;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    getTask() {
      return (
        this.$store.getters.isMatcherApiV2Enabled ? tasksApiV2 : tasksApiV1
      )
        .getTask(this.task_id)
        .then((task) => {
          this.task = task;
        });
    },
    createImportSession() {
      if (!this.$refs.form.validate()) return Promise.reject('invalid');
      // This should only be done for Matcher V1 Tasks
      return tasksApiV1
        .createMatcherTaskImportSession({
          taskId: this.task_id,
          environment: this.selectedEnv,
          business: this.selectedBusiness
        })
        .then((response) => {
          this.task = response;
        });
    }
  }
};
</script>

<style lang="scss">
.form {
  width: 100%;
  max-width: 350px;
}
.env-chip {
  min-width: 100px;
}
</style>
